"use client";
// components/common/ParallaxContainer.jsx
import { useEffect } from "react";
import "jarallax/dist/jarallax.min.css";

// El contenedor se dibuja en el SERVER, con sus hijos adentro. Antes era un
// dynamic(..., { ssr: false }) y todo lo que envolvia quedaba afuera del HTML: la home
// le llegaba a Google y a los asistentes de IA con 43 palabras (menu y pie), sin el h1
// ni el boton a los libros, y es la segunda pagina que mas abre ChatGPT (9-oct-2026).
// Lo unico que necesita el navegador es jarallax, que toca window al cargarse: por eso
// se importa adentro del efecto y no arriba.
export default function ParallaxContainer({ children, ...props }) {
  useEffect(() => {
    let cancelado = false;
    import("jarallax")
      .then(({ jarallax }) => {
        if (cancelado) return;
        jarallax(document.querySelectorAll(".parallax-5"), { speed: 0.5 });
      })
      .catch(() => {
        // Sin jarallax el fondo queda fijo (el background-image del style): se ve igual.
      });
    return () => {
      cancelado = true;
    };
  }, []);

  return <div {...props}>{children}</div>;
}
